import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IWorkflowStep, IWorkflowStepInput } from "@/interfaces/workflow-step.interface";
import workflowStepService from "@/services/workflow-steps";
import { RequestsProps } from "@/types/requests.types";

export type CreateWorkflowStepProps = {
  formData: IWorkflowStepInput;
} & RequestsProps;

export type UseCreateWorkflowStepReturn = {
  create: (props: CreateWorkflowStepProps) => Promise<IWorkflowStep>;
} & UseLoadingReturn;

const useCreateWorkflowStep = (): UseCreateWorkflowStepReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<IWorkflowStepInput>({
      operation: (formData) => workflowStepService.create(formData),
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateWorkflowStep;
